export const selectLabTests = (state) => state.labTests;
export const selectTenantLabTests = (state) => state.tenantLabTests;
export const selectVendors = (state) => state.labTests && state.labTests.vendors;
export const selectTestFormats = (state) => state.labTests && state.labTests.testFormat;
